import React from 'react';
import {
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
} from '@mui/material';

function Step3() {
    const [status, setStatus] = React.useState('default');

    const handleStatusChange = (event: SelectChangeEvent) => {
        setStatus(event.target.value as string);
    };

    return (
        <>
            <div className="form">
                <h3 className="hd_6">Reason for Closure</h3>

                <div className="control_group mt_20">
                    <label htmlFor="reason">Select reason</label>
                    <Select
                        id="reason"
                        fullWidth
                        value={status}
                        onChange={handleStatusChange}
                    >
                        <MenuItem disabled value="default">Select</MenuItem>
                        <MenuItem value="Business Closed">Business Closed</MenuItem>
                        <MenuItem value="Switching to Another Platform">Switching to Another Platform</MenuItem>
                        <MenuItem value="Taking a Break">Taking a Break</MenuItem>
                        <MenuItem value="Not Getting Enough Sales">Not Getting Enough Sales</MenuItem>
                        <MenuItem value="Facing Technical Issues">Facing Technical Issues</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                    </Select>
                </div>

                {status === 'Other' && (
                    <div className="control_group mt_20">
                        <TextField
                            hiddenLabel
                            fullWidth
                            multiline
                            placeholder="Enter Reason"
                        />
                    </div>
                )}
            </div>
        </>
    );
}

export default Step3;
